<template>
  <div
    class="form-item form-certify"
    :class="{
      'form-certify-active': currentVal,
      'form-certify-error': !currentVal && error,
    }"
  >
    <input type="checkbox" :id="id" v-model="currentVal" required />
    <label :for="id">
      <div class="iconfont  icon-duigou" :class="currentVal ? 'iskeepup' : ''"></div>
      {{ content }}
    </label>
  </div>
</template>
<script>
export default {
  props: ["content", "id", "value", "error"],
  data() {
    return {
      currentVal: false,
    };
  },
  watch: {
    value(newV) {
      this.currentVal = newV;
    },
    currentVal(newV) {
      this.$emit("input", newV);
      this.$emit("change", newV);
    },
  },
};
</script>
<style scoped lang='scss'>
.form-certify {
  width: 100%;
  display: flex;
  & > input {
    opacity: 0;
    width: 24px;
    position: absolute;
    height: 24px;
  }
  & > label {
    display: flex;
    cursor: pointer;
    .icon-duigou {
      margin-top: 4px;
      min-width: 18px;
      max-width: 18px;
      min-height: 18px;
      max-height: 18px;
      margin-right: 4px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      text-align: center;
      line-height: 17px;
      font-size: 13px;
      font-weight: 600;
    }
  }

  &:not(.form-certify-active) .icon-duigou{
    color: transparent !important;
  }
  &.form-certify-active {
    .icon-duigou {
      background: #0f88a7;
      border: 1px solid #0f88a7;
      color: white;
    }
  }
  &.form-certify-error {
    .icon-duigou {
      border: 1px solid #e32c2b;
      box-shadow: 0 0 0 1px #e32c2b;
    }
  }
}
</style>